import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import Props from '@/components/shared/components/price-view/discount-label/type';

import { DATA_CY_PRODUCT_DISCOUNT_BADGE } from '@/constant/cypress';

export default function DiscountLabel({ discount, className, discountClassName }: Props) {
  return (
    <Container
      center
      data-cy={DATA_CY_PRODUCT_DISCOUNT_BADGE}
      className={cn(
        'h-9 w-9 rounded-lg bg-[linear-gradient(257.48deg,_#FF9606_4.12%,_#F9BB00_95.45%)] p-2',
        className,
      )}
    >
      <Text bold className={cn('text-base text-[#FFFFFF]', discountClassName)}>
        {discount}&#37;
      </Text>
    </Container>
  );
}
